import React from 'react';
import PropTypes from 'prop-types';


import * as paginationConstants from './paginationConstants';
import * as styleUtils from '../../../utils/styleUtils';

import {Icon, iconConstants} from '../Icon';

import styles from './Pagination.scss';


function Pagination(
    {
        currentElements,
        isEmpty,
        isFirst,
        isLast,
        onGoToPage,
        page,
        pageSize,
        totalElements,
        totalPages
    }
) {
    const goToPage = (event, newPage) => {

        event.preventDefault();
        event.stopPropagation();

        if (newPage === page || newPage < 0 || newPage >= totalPages) {

            return;
        }

        onGoToPage(newPage);
    };

    let start = page - paginationConstants.PAGES_HALF;
    let end = page + paginationConstants.PAGES_HALF;
    if (start < 0) {
        end += Math.abs(start);
        start = 0;
    }
    if (end >= totalPages) {
        start -= end - totalPages;
        end = totalPages - 1;
    }

    // hard boundaries
    if (start < 0) {
        start = 0;
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <div className={styles.pagination}>

            <a
                className={!isFirst ? styles.active : null}
                onClick={event => goToPage(event, page - 1)}
            >
                <Icon icon={iconConstants.ICON_LEFT}/>
            </a>

            {pages.map(currentPage => (
                <a
                    className={styleUtils.toClasses(styles.pageNumber, currentPage === page ? styles.active : null)}
                    key={`page-${currentPage}`}
                    onClick={event => goToPage(event, currentPage)}
                >
                    {currentPage + 1}
                </a>
            ))}

            <a
                className={!isLast ? styles.active : null}
                onClick={event => goToPage(event, page + 1)}
            >
                <Icon icon={iconConstants.ICON_RIGHT}/>
            </a>

        </div>
    );
}


Pagination.propTypes = {
    currentElements: PropTypes.number.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    isFirst: PropTypes.bool.isRequired,
    isLast: PropTypes.bool.isRequired,
    onGoToPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalElements: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired
};


Pagination.defaultProps = {
    currentElements: 0,
    isEmpty: true,
    isFirst: true,
    isLast: true,
    page: 0,
    pageSize: 12,
    totalElements: 0,
    totalPages: 0
};


export default Pagination;
